import { useNavigate } from 'react-router-dom';
import { TenantOnboardingWizard } from '../../components/tenants/TenantOnboardingWizard';
import { PageHeading } from '../../layouts/PageHeading';

export default function TenantsNew() {
  const navigate = useNavigate();
  return (
    <div>
      <PageHeading scope="Tenants" target="nuovo" meta="Onboarding di un nuovo tenant" />
      <TenantOnboardingWizard onSuccess={(id) => navigate(`/admin/tenants/${id}?tab=overview`)} />
    </div>
  );
}
